import { render, staticRenderFns } from "./role-cusMgrLeader-list.vue?vue&type=template&id=487853cd&scoped=true"
import script from "./role-cusMgrLeader-list.vue?vue&type=script&lang=js"
export * from "./role-cusMgrLeader-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487853cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487853cd')) {
      api.createRecord('487853cd', component.options)
    } else {
      api.reload('487853cd', component.options)
    }
    module.hot.accept("./role-cusMgrLeader-list.vue?vue&type=template&id=487853cd&scoped=true", function () {
      api.rerender('487853cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/role-cusMgrLeader-list.vue"
export default component.exports